import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/home';

export default function HotTracking() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 340;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -amount : amount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-foreground-950">
      <div className="px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
            <div className="flex-1">
              <Link
                to="/category/all"
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-background-50/20 text-background-50/80 text-xs font-medium hover:border-background-50/40 transition-colors whitespace-nowrap cursor-pointer"
              >
                换一批
                <i className="ri-refresh-line"></i>
              </Link>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 mt-4">
                24 小时热点追踪
              </h2>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => scroll('left')}
                className="w-10 h-10 rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 flex items-center justify-center transition-colors cursor-pointer"
                aria-label="向左滚动"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                onClick={() => scroll('right')}
                className="w-10 h-10 rounded-full border border-background-50/20 text-background-50/60 hover:text-background-50 hover:border-background-50/40 flex items-center justify-center transition-colors cursor-pointer"
                aria-label="向右滚动"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-4 -mx-4 px-4 md:-mx-6 md:px-6"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {hotArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="flex-shrink-0 w-72 md:w-80 cursor-pointer group"
                style={{ scrollSnapAlign: 'start' }}
              >
                <div className="rounded-2xl overflow-hidden bg-background-100 transition-transform duration-300 group-hover:-translate-y-1">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-4 md:p-5">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                        {article.category}
                      </span>
                      <span className="text-xs text-foreground-400">{article.date}</span>
                    </div>
                    <h3 className="font-heading text-sm md:text-base text-foreground-950 line-clamp-2 leading-snug">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                    <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}